export default __webpack_public_path__ + "static/media/rhenus-d.453ac78d.svg";